module.exports = __webpack_public_path__ + "img/video-poster.d066ddc8.jpg";